<div class="clearfix">
    <div class="tree-search-input with-ng-select">
        <label>Hersteller</label>
            <ng-select  [items]="makes" #makeSelect
                       placeholder="Suche"
                       bindLabel="display"
                       bindValue="value"
                        [notFoundText]="notFoundText"
                        [compareWith]="compareManufacturer"
                        [selectOnTab]="true"
                        (ngModelChange)="updateMainTypes()"
                        (open)="emitChangeEvent()"
                       [(ngModel)]="vehicleIdentification.manufacturer">
            </ng-select>
       <br/>
        <label>Haupttyp</label>
        <ng-select  [items]="mainTypes" #mainTypeSelect
                    placeholder="Suche"
                    bindLabel="display"
                    bindValue="value"
                    [notFoundText]="notFoundText"
                    [selectOnTab]="true"
                    (ngModelChange)="updateSubTypes()"
                    [compareWith]="compareMainType"
                    (open)="emitChangeEvent()"
                    [(ngModel)]="vehicleIdentification.mainType">
        </ng-select>
        <br/>
        <label>Untertyp</label>
        <ng-select  [items]="subTypes" #subTypeSelect
                    placeholder="Suche"
                    bindLabel="display"
                    bindValue="value"
                    class="full-width"
                    [notFoundText]="notFoundText"
                    [selectOnTab]="true"
                    (open)="emitChangeEvent()"
                    (ngModelChange)="setSchwackeCode()"
                    [compareWith]="compareSubType"
                    [(ngModel)]="vehicleIdentification.subType">
        </ng-select>
    </div>
</div>
